import React from 'react'

export default function EstimateCard() {
  return (
    <div className="icotst15-card">
      <h3 className="icotst15-title">Your Estimated Cash Offer</h3>
      <div className="icotst15-amount">$487,500</div>

      <hr className="icotst15-divider" />

      <div className="icotst15-row">
        <span>Total Offer</span>
        <span className="icotst15-blurred">$487,500</span>
      </div>
      <div className="icotst15-row">
        <span>Closing Costs</span>
        <span className="icotst15-blurred">$12,500</span>
      </div>
      <div className="icotst15-row">
        <span>Taxes & Fees</span>
        <span className="icotst15-blurred">$3,200</span>
      </div>

      <hr className="icotst15-divider" />

      <div className="icotst15-row icotst15-highlight">
        <span>You Get</span>
        <span className="icotst15-green">$471,800</span>
      </div>

      <div className="icotst15-row">
        <span>Payment Send Date</span>
        <span style={{ filter: 'blur(8px)' }}>Mar 15, 2025</span>
      </div>

      <div className="icotst15-lock">
        <div className="icotst15-lock-circle">🔒</div>
      </div>
    </div>
  )
}
